import React from 'react';
import CookieModal from 'gatsby-core-theme/src/components/molecules/cookie-modal';

export default (props) => <CookieModal {...props} declineButtonType="tertiary" templateTwo={true} />;
